import React from "react";
import { SectionTitle } from "../EmployeeForm";
import { Dropdown } from "primereact/dropdown";
import { Button } from "../../../ui/buttons";
import { Plus, Trash2 } from "lucide-react";
import BASEURL from "../../../BaseUrl";

function HRDocuments({
  emptyHrDocument,
  hrDocuments,
  setHrDocuments,
  UploadLoader,
  updateArray,
  handleUpload,
  removeArrayItem,
}) {
  const hrDocumentTypeOptions = [
    "Offer Letter",
    "Confirmation Letter",
    "Appraisal Letter",
    "Warning Letter",
    "Termination Letter",
    "Relieving Letter",
    "Experience Letter",
    "Form 16",
    "Salary Revision Letter",
    "Increment Letter",
  ].map((x) => ({ label: x, value: x }));
  return (
    <section className="flex flex-col gap-3">
      <SectionTitle>HR Documents</SectionTitle>

      {hrDocuments.map((doc, index) => (
        <div
          key={index}
          className="grid grid-cols-1 md:grid-cols-4 gap-3 items-center border p-3 rounded-md"
        >
          <Dropdown
            value={doc.type}
            options={hrDocumentTypeOptions}
            onChange={(e) =>
              updateArray(setHrDocuments, index, "type", e.value)
            }
            placeholder="Document Type"
            className="w-full px-1 border rounded-md bg-input shadow-none focus:outline-none"
          />

          <div>
            <input
              type="file"
              accept="image/*,.pdf,.doc,.docx"
              onChange={(e) => {
                const file = e.target.files?.[0];

                handleUpload(
                  file,
                  (url) => updateArray(setHrDocuments, index, "fileUrl", url),
                  `hr-${index}`,
                );
              }}
            />

            <UploadLoader id={`hr-${index}`} />
          </div>

          {doc.fileUrl ? (
            <a
              href={`${BASEURL}${doc.fileUrl}`}
              target="_blank"
              rel="noreferrer"
              className="text-blue-600 underline"
            >
              View Uploaded
            </a>
          ) : (
            <span className="text-sm text-gray-400">Not uploaded</span>
          )}

          <Button
            type="button"
            variant="ghost"
            onClick={() => removeArrayItem(setHrDocuments, index)}
          >
            <Trash2 className="h-4 w-4 text-red-500" />
          </Button>
        </div>
      ))}

      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={() =>
          setHrDocuments((prev) => [...prev, { ...emptyHrDocument }])
        }
        className="w-fit"
      >
        <Plus className="h-4 w-4 mr-1" />
        Add HR Document
      </Button>
    </section>
  );
}

export default HRDocuments;
